import { __rest, __assign } from 'tslib';
import React, { forwardRef, useState, useRef, useEffect } from 'react';
import { Input } from '../../../../input/esm';
import { HOURS_MINUTES_SEPARATOR } from '../../consts.js';
import { isCompleteTime } from '../../utils/index.js';
import 'date-fns/differenceInDays';
import 'date-fns/format';
import 'date-fns/isSameDay';
import 'date-fns/parse';

var defaultTime = "00".concat(HOURS_MINUTES_SEPARATOR, "00");
var TimeInput = forwardRef(function (_a, ref) {
    var _b;
    var autoCorrection = _a.autoCorrection, valueProp = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, onComplete = _a.onComplete, onBlur = _a.onBlur, restProps = __rest(_a, ["autoCorrection", "value", "defaultValue", "onChange", "onComplete", "onBlur"]);
    var _c = useState(defaultValue), value = _c[0], setValue = _c[1];
    var lastValidTime = useRef(defaultTime);
    var uncontrolled = valueProp === undefined;
    var inputValue = (_b = value !== null && value !== void 0 ? value : valueProp) !== null && _b !== void 0 ? _b : '';
    useEffect(function () {
        if (autoCorrection && !inputValue) {
            lastValidTime.current = defaultTime;
        }
    }, [autoCorrection, inputValue]);
    var callOnComplete = function (val) {
        onComplete === null || onComplete === void 0 ? void 0 : onComplete(val);
        lastValidTime.current = val;
    };
    var changeValue = function (val, event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event, { value: val });
        if (uncontrolled)
            setValue(val);
        if (isCompleteTime(val, true))
            callOnComplete(val);
    };
    var handleChange = function (event) {
        changeValue(event.target.value, event);
    };
    var handleBlur = function (event) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        if (autoCorrection && inputValue && !isCompleteTime(inputValue, true)) {
            changeValue(lastValidTime.current, null);
        }
    };
    return (React.createElement(Input, __assign({}, restProps, { onBlur: handleBlur, onInput: handleChange, ref: ref, value: inputValue, inputMode: 'decimal' })));
});

export { TimeInput };
